/**
 * TenantUpdating.tsx — ekran „Trwa aktualizacja systemu” (ADR-0113b §5).
 *
 * Baza firmy jest na serwerze klienta i nie przeszła aktualizacji przy wdrożeniu — firma jest
 * chwilowo zablokowana (API: 503 TENANT_UPDATING), dopóki ITE jej nie dociągnie. `App.tsx`
 * renderuje ten ekran zamiast tras tenanta, gdy przechwytywanie odpowiedzi (`lib/api.ts`)
 * zobaczy taką odpowiedź. Sesja zostaje ważna — „Odśwież” po dociągnięciu wraca do pracy bez
 * ponownego logowania. „Zaloguj do innej firmy” prowadzi na logowanie centralne (wybór firmy) —
 * użytkownik kilku firm nie utyka na zablokowanej.
 */

import { useTranslation } from 'react-i18next';
import { RefreshCw } from 'lucide-react';

import { Button } from '@/components/Button';
import { clearTenantUpdating } from '@/lib/tenant-updating';
import { buildCentralLoginUrl } from '@/lib/tenant-url';

export function TenantUpdating() {
  const { t } = useTranslation();

  const retry = () => {
    clearTenantUpdating();
    window.location.reload();
  };

  const otherCompany = () => {
    window.location.href = buildCentralLoginUrl();
  };

  return (
    <main
      className="flex min-h-screen items-center justify-center bg-bg-secondary p-4"
      data-testid="tenant-updating"
    >
      <div className="w-full max-w-lg rounded-2xl border border-border-secondary bg-bg-elevated p-8 text-center shadow-xl">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-warning-50 text-warning-700">
          <RefreshCw size={24} aria-hidden="true" />
        </div>
        <h1 className="mb-3 text-2xl font-bold text-text-primary">{t('tenantUpdating.title')}</h1>
        <p className="mb-2 text-sm text-text-secondary">{t('tenantUpdating.body')}</p>
        <p className="mb-6 text-sm text-text-tertiary">{t('tenantUpdating.hint')}</p>
        <div className="flex flex-col items-center justify-center gap-2 sm:flex-row">
          <Button onClick={retry} data-testid="tenant-updating-retry">
            {t('tenantUpdating.retry')}
          </Button>
          <Button variant="secondary" onClick={otherCompany} data-testid="tenant-updating-other">
            {t('tenantUpdating.otherCompany')}
          </Button>
        </div>
      </div>
    </main>
  );
}
